const testimonials = [
  {
    name: "Michael B.",
    location: "Healdsburg, CA",
    rating: 5,
    text: "I own a small winery and got a last-minute invitation to Vinexpo in Bordeaux — two weeks out. My passport expired the previous year and I had not noticed. Fast Passport Center was incredibly fast and professional. They reviewed my documents, flagged a photo issue before I sent it, and had my new passport back to me in 8 business days. I made Vinexpo and closed two export agreements. Worth every single dollar.",
    service: "Emergency Renewal",
  },
  {
    name: "Patricia M.",
    location: "Oakmont, Santa Rosa",
    rating: 5,
    text: "My husband and I had been planning a European river cruise for over a year. A month before departure I realized my passport had expired during COVID. I was panicking. A friend at Oakmont recommended Fast Passport Center. They were patient, clear, and incredibly efficient. My renewed passport arrived 9 days after I shipped my documents. We sailed on schedule and had the trip of our lives.",
    service: "Expedited Renewal",
  },
  {
    name: "Sofia R.",
    location: "Santa Rosa, CA",
    rating: 5,
    text: "Our church was sending a mission team to Guatemala and I had never gotten a passport before. I had no idea how the process worked. Fast Passport Center explained everything — the acceptance clerk visit, the photos, all of it — and handled the expedited part after I visited the post office. My passport arrived with a week to spare. The whole team made it. I will always use them.",
    service: "New Passport",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function SantaRosaTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Sonoma County Travelers Say About Our Emergency &amp; Expedited Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Santa Rosa, Healdsburg, and Oakmont travelers who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col">
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}